import { type ComponentProps, type ComponentType, forwardRef } from 'react';
import cl from 'clsx';

import { CssSpinner, type CssSpinnerProps } from '../Loading';

import baseClasses from './Button.module.scss';

export type ButtonProps = Omit<ComponentProps<'button'>, 'className'> & {
  PrefixIcon?: ComponentType<ComponentProps<'svg'>>;

  SuffixIcon?: ComponentType<ComponentProps<'svg'>>;

  loading?: boolean;
  classes: {
    root: string;
    content?: string;
    loading?: string;
    prefixIcon?: string;
    suffixIcon?: string;
    spinner?: CssSpinnerProps['classes'];
  };
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  function Button(
    {
      type = 'button',

      PrefixIcon,

      SuffixIcon,

      children,

      disabled: disabledProp,
      loading = false,

      classes,

      ...rest
    },
    ref,
  ) {
    const disabled = disabledProp || loading;
    return (
      <button
        type={type}
        ref={ref}
        disabled={disabled}
        className={cl(baseClasses.root, classes.root, {
          ...(classes.loading
            ? {
                [classes.loading]: loading,
              }
            : {}),
        })}
        {...rest}
      >
        {PrefixIcon && <PrefixIcon className={classes.prefixIcon} />}
        <div className={classes.content}>{children}</div>

        {/* either Spinner either SuffixIcon, not both */}
        {loading
          ? classes.spinner && <CssSpinner classes={classes.spinner} />
          : SuffixIcon && <SuffixIcon className={classes.suffixIcon} />}
      </button>
    );
  },
);
